import React from "react"

const safeLink = (value = "") => /^https?:\/\//i.test(value) || value.startsWith("/")

const renderInline = (text, keyPrefix = "inline") => {
    const value = String(text || "")
    const pattern = /(\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*|__([^_]+)__|~~([^~]+)~~|\*([^*\n]+)\*)/g
    const content = []
    let cursor = 0
    let match

    while ((match = pattern.exec(value)) !== null) {
        if (match.index > cursor) content.push(value.slice(cursor, match.index))
        const key = `${keyPrefix}-${match.index}`
        if (match[2] !== undefined) {
            content.push(safeLink(match[3])
                ? <a key={key} href={match[3]} target={match[3].startsWith("/") ? undefined : "_blank"} rel={match[3].startsWith("/") ? undefined : "noreferrer"}>{renderInline(match[2], key)}</a>
                : match[2])
        } else if (match[4] !== undefined) {
            content.push(<strong key={key}>{renderInline(match[4], key)}</strong>)
        } else if (match[5] !== undefined) {
            content.push(<u key={key}>{renderInline(match[5], key)}</u>)
        } else if (match[6] !== undefined) {
            content.push(<del key={key}>{renderInline(match[6], key)}</del>)
        } else if (match[7] !== undefined) {
            content.push(<em key={key}>{renderInline(match[7], key)}</em>)
        }
        cursor = pattern.lastIndex
    }

    if (cursor < value.length) content.push(value.slice(cursor))
    return content
}

const isBlockStart = (line = "") => /^(#{1,3}\s|[-*]\s|\d+\.\s|>\s)/.test(line.trim())

const FormattedAnnouncementText = ({ text, className = "" }) => {
    const lines = String(text || "").replace(/\r\n/g, "\n").split("\n")
    const blocks = []

    for (let index = 0; index < lines.length;) {
        const line = lines[index].trim()
        if (!line) {
            index += 1
            continue
        }

        const heading = line.match(/^(#{1,3})\s+(.+)$/)
        if (heading) {
            const level = heading[1].length
            const Heading = `h${Math.min(level + 2, 5)}`
            blocks.push(<Heading key={`heading-${index}`}>{renderInline(heading[2], `heading-${index}`)}</Heading>)
            index += 1
            continue
        }

        if (/^[-*]\s+/.test(line)) {
            const items = []
            while (index < lines.length && /^[-*]\s+/.test(lines[index].trim())) {
                items.push(<li key={`item-${index}`}>{renderInline(lines[index].trim().replace(/^[-*]\s+/, ""), `item-${index}`)}</li>)
                index += 1
            }
            blocks.push(<ul key={`list-${index}`}>{items}</ul>)
            continue
        }

        if (/^\d+\.\s+/.test(line)) {
            const items = []
            while (index < lines.length && /^\d+\.\s+/.test(lines[index].trim())) {
                items.push(<li key={`ordered-item-${index}`}>{renderInline(lines[index].trim().replace(/^\d+\.\s+/, ""), `ordered-item-${index}`)}</li>)
                index += 1
            }
            blocks.push(<ol key={`ordered-list-${index}`}>{items}</ol>)
            continue
        }

        if (/^>\s+/.test(line)) {
            const quote = []
            while (index < lines.length && /^>\s+/.test(lines[index].trim())) {
                quote.push(lines[index].trim().replace(/^>\s+/, ""))
                index += 1
            }
            blocks.push(<blockquote key={`quote-${index}`}>{renderInline(quote.join(" "), `quote-${index}`)}</blockquote>)
            continue
        }

        const paragraph = [line]
        index += 1
        while (index < lines.length && lines[index].trim() && !isBlockStart(lines[index])) {
            paragraph.push(lines[index].trim())
            index += 1
        }
        blocks.push(<p key={`paragraph-${index}`}>{renderInline(paragraph.join(" "), `paragraph-${index}`)}</p>)
    }

    return <div className={className}>{blocks}</div>
}

export default FormattedAnnouncementText
